import React, { useState } from "react";
import "../index.css";
import { IoIosSearch } from "react-icons/io";
import { useLocation } from "react-router-dom";
import { Pagination } from "antd";
import { useDebounce } from "../../../hooks/useDebounce";

const Index = ({
  children,
  arg: { pageC, setPageC, totaltech, setSearchData, setSearchSurveyData },
}) => {
  const location = useLocation();

  // console.log("location in sidebar----->", location); //useLocation
  const [current, setCurrent] = useState(1);
  const [searchValue, setSearchValue] = useState("");

  const onChange = (page) => {
    // console.log(page);
    setCurrent(page);
    setPageC(page);
  };


  // Debounced search function
  const handleSearchDebounced = useDebounce((value) => {
    setSearchData(value);
    console.log(value); // You can log it or handle the actual search API call here
  }, 900); // Set delay time as per your requirement (500ms is common)

  const handleSurveySearchDebounced = useDebounce((value) => {
    setSearchSurveyData(value);
    console.log(value); // You can log it or handle the actual search API call here
  }, 900); // Set delay time as per your requirement

  // Handle change and trigger debounce
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    handleSearchDebounced(value);
  };

  const handleSurveySearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    handleSurveySearchDebounced(value);
  };

  return (
    <div
      className={` ${location.pathname === "/update" ? "sidebarnone" : "sidebar"
        }`}
    >
      <div>
        <div className="position-relative">
          <input
            type="search"
            className="form-control form-control-sm pe-7"
            placeholder="Search Orders"
            onChange={
              location.pathname === "/technicians"
                ? handleSearch
                : handleSurveySearch
            }
          />
          {searchValue.length === 0 && (
            <IoIosSearch
              className="position-absolute top-50 translate-middle-y text-muted pe-none fs-5"
              style={{ right: '0.5rem', pointerEvents: 'none' }}
              aria-hidden="true"
            />
          )}
        </div>
        <div className="mt-3" style={{ fontSize: "12px" }}>
          Showing {totaltech} results
        </div>
      </div>
      <div>{children}</div>
      <Pagination
        current={pageC}
        onChange={onChange}
        total={totaltech}
        className="mt-3"
        showSizeChanger={false}
      />
    </div>
  );
};

export default Index;
